import { EhrReprescribingPrefill } from '../../../../../features/ehr-launch/ehrLaunchPatientApi'
import { PrescribedItem } from '../../../../../types'
import { ProductDetails } from '../../ProductSearchContextSlice'
import { detailsToPrescribedItem } from './handlers'
import { preCheckProduct } from './preCheckProduct'

export interface PrepareMimsPrescribedItemOptions {
  overrides?: Partial<PrescribedItem>
  ctgFlag?: boolean
  isAbleToSelectS8Medicine: boolean
  ehrPrefill?: EhrReprescribingPrefill
}

export type PrepareMimsPrescribedItemResult =
  | { passed: true; item: PrescribedItem; message?: string }
  | { passed: false; reason: 'schedule_8' | 'precheck'; message?: string }

export const prepareMimsPrescribedItem = (
  product: ProductDetails,
  options: PrepareMimsPrescribedItemOptions
): PrepareMimsPrescribedItemResult => {
  if (
    !options.isAbleToSelectS8Medicine &&
    product.poisonClassification?.poisonClasses?.includes('S8')
  ) {
    return {
      passed: false,
      reason: 'schedule_8',
      message: 'Selection of S8 controlled substance is prohibited.',
    }
  }

  const item = detailsToPrescribedItem(product, options.overrides, options.ctgFlag)
  const check = preCheckProduct(item.productDetails)
  if (!check.passed) return { passed: false, reason: 'precheck', message: check.message }

  return {
    passed: true,
    item: {
      ...item,
      ...(options.ehrPrefill ?? {}),
    },
    ...(check.message ? { message: check.message } : {}),
  }
}
